export function ucfirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const slugify = (text) => {  
    // Convert the text to lowercase
    const normalizedText = text.toString().toLowerCase();
  
    // Replace accented characters with their non-accented equivalents
    const slugifiedText = normalizedText
      // Normalize accents: decompose accented characters into base characters and combining diacritical marks
      .normalize('NFD')
      // Remove remaining diacritical marks
      .replace(/[\u0300-\u036f]/g, '')
      // Remove non-alphanumeric, non-space, and non-dash characters
      .replace(/[^\w\s-]/g, '')
      // Replace spaces with dashes
      .replace(/\s+/g, '-')
      // Replace sequences of spaces or dashes with a single dash
      .replace(/[-\s]+/g, '-')
      // Trim spaces from the beginning and end of the string
      .replace(/^\s+|\s+$/g, '');
  
    return slugifiedText;
  };

  export const isPasswordComplexityOK = (password) => {
    return /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}/.test(password);
  };
